import React, { Component } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Style.scss";
import technology from "../../../Assets/Images/Technology_icon.svg";
import product from "../../../Assets/Images/products_icon.svg";
import accounts from "../../../Assets/Images/accounts_icon.svg";
import pricing from "../../../Assets/Images/Pricing_icon.svg";
import AccountOpening from "../Account/AccountOpening";

export class Why extends Component {
  render() {
    return (
      <>
        <section className="whySectionContainer">
          <Container className="whySection">
            <Container className="headingTxt">
              <h1>Why OPG Account?</h1>
              <h6 className="subTitle">
                New traders or seasoned professionals can experience the full
                suite of powerful trading technology, online brokerage services,
                and trading education all under one roof.
              </h6>
            </Container>
            <Container className="container">
              <Row className="whyCards row">
                <Col md={6} sm={12} xs={12} className="whyCard col-md-6">
                  <div className="innerWhyCard">
                    <img
                      src={technology}
                      alt="Technology OPG Securities Illustration"
                      className="whyImg"
                      width={100}
                    />
                    <h3 className="title">Technology</h3>
                    <p className="cardDisc">
                      Cutting edge trading technology that provides power,
                      reliability, and mobility
                    </p>
                  </div>
                </Col>
                <Col md={6} sm={12} xs={12} className="whyCard col-md-6">
                  <div className="innerWhyCard">
                    <img
                      src={product}
                      alt="Products OPG Securities Illustration"
                      className="whyImg"
                      width={100}
                    />
                    <h3 className="title">Products</h3>
                    <p className="cardDisc">
                      A complete product kit, customised products as per your
                      requirements
                    </p>
                  </div>
                </Col>
                <Col md={6} sm={12} xs={12} className="whyCard col-md-6">
                  <div className="innerWhy">
                    <img
                      src={accounts}
                      alt="Accounts OPG Securities Illustration"
                      className="whyImg"
                      width={100}
                    />
                    <h3 className="title">Accounts</h3>
                    <p className="cardDisc">
                      Paperless account opening, Forget the hassle of physical
                      forms. Just fill out the forms online.
                    </p>
                  </div>
                </Col>
                <Col md={6} sm={12} xs={12} className="whyCard col-md-6">
                  <div className="innerWhyCard">
                    <img
                      src={pricing}
                      alt="Pricing OPG Securities Illustration"
                      className="whyImg"
                      width={100}
                    />
                    <h3 className="title">Pricing</h3>
                    <p className="cardDisc">
                      Choose a brokerage plan that suits your goals, Trade with
                      better margins now!
                    </p>
                  </div>
                </Col>
              </Row>
            </Container>
          </Container>
          <AccountOpening />
        </section>
      </>
    );
  }
}

export default Why;
